const shortMonth = (year: number, monthIndex: number): string =>
  new Date(Date.UTC(year, monthIndex, 1)).toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  })

/**
 * UTC quarter a timestamp falls in, with its short month range. The range is
 * derived from the quarter index, not the point's own date, so any timestamp
 * inside the quarter (start, month end, latest day) reads e.g. "Apr" – "Jun".
 */
export function getUTCQuarter(timestamp: number): {
  quarter: number
  year: number
  startMonth: string
  endMonth: string
} {
  const date = new Date(timestamp)
  const year = date.getUTCFullYear()
  const startMonthIndex = Math.floor(date.getUTCMonth() / 3) * 3
  const quarter = startMonthIndex / 3 + 1
  return {
    quarter,
    year,
    startMonth: shortMonth(year, startMonthIndex),
    endMonth: shortMonth(year, startMonthIndex + 2),
  }
}
